import React from 'react';

const GuideContext = React.createContext({});
export default GuideContext;
